/**
 * Base URL for the platform API.
 *
 * Production (NODE_ENV === 'production'):
 * - REACT_APP_API_ORIGIN if set (build-time override)
 * - Else https://stans-world.onrender.com
 *
 * Development:
 * - REACT_APP_API_ORIGIN — fixed base (optional)
 * - Else: same host as the page, port REACT_APP_API_PORT or 4000
 *
 * Override examples:
 *   REACT_APP_API_ORIGIN=http://127.0.0.1:4000
 *   REACT_APP_API_PORT=4000
 */
function trimOrigin(value) {
  return typeof value === 'string' ? value.replace(/\/$/, '') : '';
}

const DEFAULT_PRODUCTION_API_ORIGIN = 'https://stans-world.onrender.com';

const fromEnv = trimOrigin(process.env.REACT_APP_API_ORIGIN);
const apiPort = process.env.REACT_APP_API_PORT || '4000';

/** Resolved API origin (absolute in dev and in production builds). */
export function getApiOrigin() {
  if (process.env.NODE_ENV === 'production') {
    return fromEnv || DEFAULT_PRODUCTION_API_ORIGIN;
  }
  if (fromEnv) {
    return fromEnv;
  }
  if (typeof window !== 'undefined' && window.location?.hostname) {
    const { protocol, hostname } = window.location;
    return `${protocol}//${hostname}:${apiPort}`;
  }
  return `http://localhost:${apiPort}`;
}

/** Absolute API URL (Render in production by default; local API in dev). */
export function apiUrl(path) {
  const p = path.startsWith('/') ? path : `/${path}`;
  const base = getApiOrigin();
  return base ? `${base}${p}` : p;
}
